module.exports = __webpack_public_path__ + "img/1F55B.4112cc67.svg";